import {DotProps} from "@/components/dot/Dot.types.ts";
import classNames from "classnames";
import {forwardRef} from "react";
import styles from "./Dot.module.scss";

export const Dot = forwardRef<HTMLDivElement, DotProps>(
  ({className, variant, size = "default", animation, ...props}, ref) => {
    return (
      <div
        ref={ref}
        className={classNames(styles.dot, styles[variant], styles[size], animation && styles[animation], className)}
        {...props}
      />
    );
  }
);
